import { tenant } from '@tenant';

const { colors } = tenant;

const hexToRgba = (hex: string, alpha: number) => {
  const red = parseInt(hex.slice(1, 3), 16);
  const green = parseInt(hex.slice(3, 5), 16);
  const blue = parseInt(hex.slice(5, 7), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

const CONTROL_HEIGHT = 47;
const BORDER_RADIUS_LG = 16;
const BORDER_RADIUS_FULL = 9999;
export const ANTD_THEME = {
  components: {
    Alert: {
      borderRadius: BORDER_RADIUS_LG,
      borderRadiusLG: BORDER_RADIUS_LG,
      borderRadiusSM: BORDER_RADIUS_LG
    },
    Select: {
      colorPrimary: colors.actionSelected,
      optionSelectedColor: 'rgba(0, 0, 0, 0.88)',
      optionSelectedBg: 'rgba(234, 234, 234, 0.27)',
      controlHeight: CONTROL_HEIGHT,
      controlHeightLG: CONTROL_HEIGHT,
      controlHeightSM: CONTROL_HEIGHT,
      optionLineHeight: 3,
      borderRadius: BORDER_RADIUS_LG,
      borderRadiusLG: BORDER_RADIUS_LG,
      colorTextDisabled: 'rgb(0,0,0)',
      boxShadowSecondary:
        '12px 12px 12px 12px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
    },
    Slider: {
      colorBgElevated: colors.tenantPrimary,
      handleColor: colors.tenantPrimary,
      trackBg: colors.tenantPrimary
    },
    Collapse: {
      contentBg: 'rgb(255, 255, 255)',
      headerPadding: '22px 24px',
      contentPadding: '16px 24px',
      fontSizeIcon: 18
    },
    Dropdown: {
      controlItemBgActiveHover: colors.surfaceActive,
      controlItemBgActive: hexToRgba(colors.surfaceActive, 0.6),
      borderRadius: BORDER_RADIUS_LG
    },
    Table: {
      rowHoverBg: colors.surfaceHover,
      fontSize: 16,
      headerSplitColor: 'rgba(0, 0, 0, 0)',
      bodySortBg: 'rgba(255, 255, 255, 0)',
      footerBg: colors.surfaceMuted
    },
    Tag: {
      defaultBg: colors.feedbackInfoMuted,
      borderRadiusSM: BORDER_RADIUS_LG
    },
    Button: {
      colorTextLightSolid: colors.contentOnAccent,
      // 'null' is deliberately invalid CSS: it suppresses antd's default
      // primary-button shadow. Removing it makes the shadow reappear.
      primaryShadow: 'null',
      paddingBlockLG: 9,
      paddingBlock: 7,
      contentFontSize: 14,
      paddingInlineSM: 16,
      paddingInline: 24,
      paddingInlineLG: 24,
      controlHeight: CONTROL_HEIGHT,
      controlHeightLG: CONTROL_HEIGHT,
      controlHeightSM: CONTROL_HEIGHT,
      borderRadius: BORDER_RADIUS_FULL,
      borderRadiusLG: BORDER_RADIUS_FULL,
      borderRadiusSM: BORDER_RADIUS_FULL,
      colorBgContainer: 'rgb(255,255,255)',
      colorPrimary: colors.actionSecondary,
      colorPrimaryHover: colors.actionSecondaryHover,
      colorPrimaryActive: colors.actionSecondaryActive,
      defaultHoverBg: 'rgb(242,242,242)',
      defaultHoverBorderColor: colors.borderSoft,
      defaultHoverColor: colors.contentOnAccent,
      dangerColor: 'rgb(255,255,255)'
    },
    TreeSelect: {
      nodeSelectedBg: 'rgb(245,245,245)'
    },
    Modal: {
      colorIcon: 'rgb(0,0,0)',
      borderRadiusLG: BORDER_RADIUS_LG
    },
    DatePicker: {
      colorPrimary: colors.tenantPrimary,
      cellActiveWithRangeBg: colors.contentBrandFaint
    },
    Input: {
      borderRadius: BORDER_RADIUS_LG,
      borderRadiusLG: BORDER_RADIUS_LG,
      borderRadiusSM: BORDER_RADIUS_LG,
      controlHeight: CONTROL_HEIGHT,
      controlHeightLG: CONTROL_HEIGHT,
      controlHeightSM: CONTROL_HEIGHT
    }
  },
  token: {
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    colorPrimary: colors.tenantPrimary,
    colorInfo: colors.tenantPrimary,
    colorError: colors.feedbackError,
    colorWarning: colors.feedbackWarning,
    colorSuccess: colors.feedbackSuccess
  }
};
